import { CantileverButton } from 'components/CantileverButton'
import { Dropdown } from 'components/form/inputs/Dropdown'
import { TextInput } from 'components/form/inputs/TextInput'
import { useNodePropertyPanel } from 'features/processFlowDiagrams/components/nodes/propertyPanel/NodePropertyPanelContext'
import {
  FormSection,
  InputColumn,
  InputRow,
  PercentageControls,
  PercentageDisplay,
  rotationOptions,
  SectionTitle,
} from 'features/processFlowDiagrams/components/nodes/propertyPanel/StylesAndHelper'
import React from 'react'

/** Size, position, and rotation controls for the selected node. */
export const TransformSection: React.FC = () => {
  const {
    selectedNodeId,
    xPosition,
    yPosition,
    scale,
    rotation,
    handlePositionXChange,
    handlePositionYChange,
    handleRotationChange,
    increaseSize,
    decreaseSize,
  } = useNodePropertyPanel()

  return (
    <>
      <FormSection>
        <SectionTitle>Size</SectionTitle>
        <PercentageControls>
          <CantileverButton
            onClick={decreaseSize}
            disabled={scale <= 20}
            title='Decrease size by 10%'
            iconOnly
            square>
            −
          </CantileverButton>
          <PercentageDisplay>{scale}%</PercentageDisplay>
          <CantileverButton
            onClick={increaseSize}
            disabled={scale >= 1000}
            title='Increase size by 10%'
            iconOnly
            square>
            +
          </CantileverButton>
        </PercentageControls>
      </FormSection>

      <FormSection>
        <SectionTitle>Position</SectionTitle>
        <InputRow>
          <InputColumn>
            <TextInput
              $label='X'
              value={String(xPosition || '')}
              onChange={(e) => handlePositionXChange(e.target.value)}
              placeholder='X Position'
            />
          </InputColumn>
          <InputColumn>
            <TextInput
              $label='Y'
              value={String(yPosition || '')}
              onChange={(e) => handlePositionYChange(e.target.value)}
              placeholder='Y Position'
            />
          </InputColumn>
        </InputRow>
      </FormSection>

      <FormSection>
        <SectionTitle>Rotation</SectionTitle>
        <Dropdown
          key={`${selectedNodeId}-rotation`}
          options={rotationOptions}
          defaultValue={String(rotation || '0')}
          onValueChange={(value) => handleRotationChange(value)}
          placeholder='Select rotation'
        />
      </FormSection>
    </>
  )
}
